import React from "react";

import { HeadlineStats } from "../HeadlineStats";
import { SalesControls } from "../SalesControls";
import { SalesChart } from "../SalesChart";
import { SalesInfoPopover } from "../SalesInfoPopover";
import { TotalCount } from "../TotalCount";
import { MusicIdProps } from "../../selectors";

export const Sales = (props: MusicIdProps) => {
    return (
        <div className="sales">
            {/* TODO change to a generic InfoPopover */}
            <SalesInfoPopover />
            <SalesControls {...props} />
            <div className="sales__stats">
                <TotalCount {...props} />
                <HeadlineStats {...props} />
            </div>
            <SalesChart {...props} />
        </div>
    );
};
